module.exports = __webpack_public_path__ + "static/data-57f21f0bfedae2def31b99be26aa6ad2.jpg";